import styled from 'styled-components';
import { IStyledProps } from '../Header/Header.interface';

export const StyledFooterIconContainer = styled('div')<IStyledProps>(
  ({ color }) => ({
    color,
  }),
);
